/**
 * Reusable Tooltip Cell Component
 * Used for table cells with truncated text and hover tooltips
 *
 * Uses the native `title` tooltip only. A custom absolute overlay was removed
 * because it painted above sticky headers (and misaligned under body zoom),
 * so hovering near column headings showed unrelated cell text.
 */
import React from 'react';

export const TooltipCell = ({
  content,
  className = '',
  children,
  align = 'center',
  style,
  ...rest
}) => {
  return (
    <td
      {...rest}
      className={`px-6 py-4 text-sm md:truncate relative text-${align} ${className}`}
      title={content}
      style={style}
    >
      <span className="block md:truncate max-md:whitespace-normal max-md:break-words">
        {children || content}
      </span>
    </td>
  );
};
